import React from 'react';
import BaseModal from 'components/BaseModal';
import { useRouter } from 'next/router';
import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';

export default function CartActivateFreeTrial({ open, onClose }) {
  const router = useRouter();
  const classes = useStyles();

  return (
    <BaseModal
      size="sm"
      open={open}
      content={
        <Box>
          <img
            width="246"
            src="/images/person-cart-offer-trial.svg"
            alt="person offer trial image"
          />

          <Typography className={classes.title}>Activate your 7-Day Free Trial</Typography>

          <Box pt={1} pb={2.5}>
            <Typography className={classes.moreInfo}>Benefits you'll get:</Typography>
          </Box>

          <Typography className={classes.moreInfo}>No more watermarks</Typography>

          <Typography className={classes.moreInfo}>Unlimited scientific illustrations</Typography>

          <Typography className={classes.moreInfo}>Unlimited editable figure</Typography>

          <Typography className={classes.moreInfo}>High definition downloads</Typography>

          <Typography className={classes.moreInfo}>And many more</Typography>
        </Box>
      }
      actionText="Get the Free Trial Now"
      cancelButton={false}
      onActionClick={() => router.push('/my-account/billing/trial-checkout')}
      onClose={onClose}
    />
  );
}
